(() => {
  const root = document.querySelector('#MainContent product-info');
  if (!root) return;
  const desktop = window.matchMedia('(min-width: 750px)');
  const tray = document.createElement('aside');
  tray.className = 'pm-ux-purchase-tray';
  tray.hidden = true;
  tray.setAttribute('aria-label', 'Add this dish to your order');
  tray.innerHTML = '<div class="pm-ux-purchase-tray__copy"><strong></strong><span></span></div><button type="button">Add to cart</button>';
  document.body.append(tray);
  const title = tray.querySelector('strong');
  const context = tray.querySelector('span');
  const action = tray.querySelector('button');
  let frame = 0;
  const update = () => {
    frame = 0;
    const source = root.querySelector('.product-form__submit');
    if (!source) { tray.hidden = true; return; }
    const r = source.getBoundingClientRect();
    const overlay = document.querySelector('dialog[open], .pm-quick-add-drawer[open], cart-drawer.active');
    tray.hidden = !desktop.matches || r.bottom > 0 || !!overlay;
    title.textContent = root.querySelector('.product__title h1')?.textContent.trim() || 'Your dish';
    const sides = root.querySelector('[data-pm-side-pickers]');
    const incomplete = sides && sides.dataset.pmComplete !== 'true';
    const busy = source.classList.contains('loading');
    const unavailable = !incomplete && (source.disabled || source.getAttribute('aria-disabled') === 'true');
    action.disabled = busy || unavailable;
    action.textContent = busy ? 'Adding…' : incomplete ? 'Choose sides' : unavailable ? source.textContent.trim() : 'Add to cart';
    const quantity = root.querySelector('quantity-input input[name="quantity"]')?.value || '1';
    context.textContent = incomplete ? 'Choose your included sides to continue' : `Quantity: ${quantity} · Review or add your dish`;
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  action.addEventListener('click', () => {
    const sides = root.querySelector('[data-pm-side-pickers]');
    if (sides && sides.dataset.pmComplete !== 'true') {
      const picker = [...sides.querySelectorAll('purefect-side-picker')].find(p => !p.querySelector('input[data-pm-real-side]:checked'));
      const details = picker?.querySelector('details');
      if (details) details.open = true;
      picker?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      picker?.querySelector('summary')?.focus({preventScroll:true});
      return;
    }
    root.querySelector('.product-form__submit')?.click();
    schedule();
  });
  new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','data-pm-complete']});
  root.addEventListener('change',schedule);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('click',schedule);
  desktop.addEventListener('change',schedule);
  update();
})();
